import React, { useRef, useState, useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Box from "@mui/material/Box";
import FirstDynamicTable from "../components/FirstDynamicTable";
import SecondDynamicTable from "../components/SecondDynamicTable";
import FourthDynamicTable from "../components/FourthDynamicTable";
import FifthDynamicTable from "../components/FifthDynamicTable";
import SixthDynamicTable from "../components/SixthDynamicTable";

import { TabSelected } from "../SXStyle";

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../microsoft/authConfig";
import { iniciarSesionMicrosoft } from "../service/apiService";


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const [isMounted, setIsMounted] = useState(false);

  //identifica si el tab esta seleccionado - util para las graficas
  useEffect(() => {
    if (value === index) {
      setIsMounted(true);
    }
  }, [value, index]);

  return (
    <div
      role="tabpanel"
      style={{
        display: value !== index ? "none" : "block",
        width: "100%",
        height: "100%",
      }}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {isMounted && value === index && (
        <Box sx={{ p: 3, width: "100%", height: "100%" }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const { instance, accounts } = useMsal();

  const [value, setValue] = useState(0);

  //Listado de excel
  const [dataExcel, setDataExcel] = useState([]);

  //efecto de loading
  const [openLoader, setOpenLoader] = useState(true);


  useEffect(() => {
    loginAndFetchExcel();
  }, [instance, accounts]);

  const loginAndFetchExcel = async () => {
    try {
      // let account = instance.getActiveAccount();

      // // Inicia sesión si no hay cuenta activa
      // if (accounts.length === 0) {
      //   const loginResponse = await instance.loginPopup(loginRequest);
      //   account = loginResponse.account;
      //   console.log("Logueado como :", loginResponse.account.username);

      //   // Lo establece como cuenta activa
      //   instance.setActiveAccount(account);
      // }

      // //Obtiene el token
      // const tokenResponse = await instance.acquireTokenSilent({
      //   ...loginRequest,
      //   account: account,
      // });

      // const accessToken = tokenResponse.accessToken;
      const accessToken = await iniciarSesionMicrosoft();

      const driveId = "b!lwp5CudIwEiBZPypSPW71y6pboWNzY9PlnZlYSQb570bW9liL1kQRIUjuEjaWYi_";
      const itemId = "01RTYIYHPKFI4ELIP45RHKBKDX6C3NKKLO";
      const worksheetName = "qry_combinado";

      const endpoint = `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${itemId}/workbook/worksheets('${worksheetName}')/usedRange`;

      // Sitio de sharepoint
      const response = await fetch(endpoint, {
        headers: {
          Authorization: `Bearer ${accessToken.data?.access_token}`,
        },
      });

      const data = await response.json();
      const allRows = data.values;

      // Elimina los encabezados del exel:
      const rowsWithoutHeader = allRows.slice(1);

      //calcula los ponderados
      setDataExcel(rowsWithoutHeader);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <Box className="min-h-[calc(82vh)] w-full flex rounded-lg shadow-xl  bg-blanco border-gray-700">
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: "divider" }}
        TabIndicatorProps={{
          sx: {
            backgroundColor: "#cb9636", // o cualquier color
            width: 3, // ancho del indicador
          },
        }}
      >
        <Tab
          label="Desarrollo Lateral & Rebajes"
          {...a11yProps(0)}
          sx={TabSelected}
        />
        <Tab
          label="Desarrollo lateral / produccion rebajes"
          {...a11yProps(1)}
          sx={TabSelected}
        />
        <Tab
          label="Alimentacion a quebradora"
          {...a11yProps(2)}
          sx={TabSelected}
        />
        <Tab
          label="Produccion diaria ore pass"
          {...a11yProps(3)}
          sx={TabSelected}
        />
        <Tab
          label="Movimiento diario por banda"
          {...a11yProps(4)}
          sx={TabSelected}
        />
  
        <Tab
          label="Extraccion de los stocks"
          {...a11yProps(5)}
          sx={TabSelected}
        />
      </Tabs>


      <TabPanel value={value} index={0}>
        <FirstDynamicTable 
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


      <TabPanel value={value} index={1}>
        <SecondDynamicTable 
          visible={value === 1}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={2}>
        Item Three
      </TabPanel>

      <TabPanel value={value} index={3}>
        <FourthDynamicTable 
          visible={value === 3}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>



      <TabPanel value={value} index={4}>
        <FifthDynamicTable 
          visible={value === 4}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


      <TabPanel value={value} index={5}>
        <SixthDynamicTable 
          visible={value === 5}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>
     
    </Box>
  );
}
